import { render, staticRenderFns } from "./contact-module.vue?vue&type=template&id=683b3dbe&scoped=true&"
import script from "./contact-module.vue?vue&type=script&lang=js&"
export * from "./contact-module.vue?vue&type=script&lang=js&"
import style0 from "./contact-module.vue?vue&type=style&index=0&id=683b3dbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683b3dbe",
  null
  
)

export default component.exports